import { Field } from 'formik';
import cn from 'classnames';
import {
  RichTextEditor,
  RichTextEditorTextSize,
  RichTextEditorToolbarItems,
} from '@viewthespace/components';
import { useFlags } from 'launchdarkly-react-client-sdk';
import FieldWrapper, { FieldWrapperProps } from '../FieldWrapper';

type Props = {
  editorClassName?: string;
  hideLabel?: boolean;
  initialContent?: string | null;
  excludeMenuItems?: RichTextEditorToolbarItems[];
  defaultTextSize?: RichTextEditorTextSize;
  onChange?: (value: string) => void;
  placeholder?: string;
  resetKey?: number;
} & Omit<FieldWrapperProps, 'children'>;

const RichTextEditorInput = ({
  name,
  editorClassName,
  inputContainerClass,
  containerClass,
  hideLabel = false,
  initialContent,
  labelText,
  required,
  excludeMenuItems = [],
  defaultTextSize,
  onChange,
  placeholder,
  resetKey = 0,
}: Props) => {
  const flags = useFlags();
  return (
    <FieldWrapper
      displayError={false}
      {...{ name, labelText, required, inputContainerClass, containerClass }}
    >
      <Field name={name}>
        {({ field, form, meta }) => (
          <RichTextEditor
            key={`rich-text-editor-${name}-${resetKey}`}
            hideLabel={hideLabel}
            testId="rich-text-editor"
            label="ignore"
            editorClassName={cn(editorClassName, 'selection:!bg-cta-primary-default')}
            name={name}
            errorText={meta.touched && meta.error ? meta.error : undefined}
            initialContent={initialContent || field.value}
            excludeMenuItems={
              flags['market.microsite-font-sizing-on-editors']
                ? excludeMenuItems
                : [...excludeMenuItems, 'textAlign']
            }
            defaultTextSize={defaultTextSize}
            placeholder={placeholder}
            onChange={value => {
              field.onChange({
                target: {
                  name: field.name,
                  value,
                },
              });
              setTimeout(() => form.setFieldTouched(field.name, true));
              if (onChange && value) {
                onChange(value);
              }
            }}
          />
        )}
      </Field>
    </FieldWrapper>
  );
};

export default RichTextEditorInput;
